import {t} from './../../../system/i18n';
export const BAG_SHIPPING_TYPE = {
    USER: 'USER',
    PARTNER: 'PARTNER'
};

export const LIST_BAG_SHIPPING_TYPE =[
    {'id': BAG_SHIPPING_TYPE.USER, 'name': t('bag:shipping_type.user')},
    {'id': BAG_SHIPPING_TYPE.PARTNER, 'name': t('bag:shipping_type.partner')}
];